import React from "react";
import { Container, Typography, Box, Grid, Button } from "@mui/material";
import Trendingcard from "./Trendingcard";

import { trending } from "./Trendingarray";
const Trending = () => {
  return (
    <React.Fragment>
      <Container>
        <Typography
          sx={{
            display: "flex",
            mt: 5,
            borderBottom: "4px solid black",
            width: { lg: "35%", md: "35%" },
            borderBottomLeftRadius: 20,
          }}
        >
          <Typography sx={{ fontSize: "2.5rem", color: "#022a6b" }}>
            Trending
          </Typography>
          <Typography
            sx={{ fontSize: "1.5rem", marginTop: 2.2, marginLeft: 1 }}
          >
            {" "}
            Collection
          </Typography>
        </Typography>
        <Typography sx={{ mt: 3, fontSize: "1.1rem" }}>
          Have a look whats trending now!
        </Typography>
        <Grid container spacing={1}>
          {trending.map((item, index) => (
            <Grid item lg={3} xs={12} md={4} sm={6}>
              {" "}
              <Trendingcard
                key={index}
                item={item}
                img={item.image}
                name={item.name}
                price={item.price}
                description={item.description}
                size1={item.size1}
                size2={item.size2}
                size3={item.size3}
                size4={item.size4}
                brand={item.brand}
                color1={item.color1}
                color2={item.color2}
                id={item.id}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default Trending;
